import { call, select } from 'redux-saga/effects';
import { includes, get } from 'lodash';

import { FETCH_CURRENT_USER, FETCH_CURRENT_MASTER } from '@lib/actions/actionTypes';
import { usersResource } from '@lib/resources';
import { selectAuthUser, selectCurrentToken, selectAuthMaster } from '@lib/selectors';
import { sagaFetch } from '@lib/sagas';
import { LOGGER_DATA_LOCAL_STORAGE_KEY } from 'ui-model';

// bind resource generator
const fetchUser = sagaFetch.bind(null, FETCH_CURRENT_USER, usersResource.fetchUser);
const fetchMaster = sagaFetch.bind(null, FETCH_CURRENT_MASTER, usersResource.fetchUser);

export default function* sagaFetchCurrentUser() {
  // fetch current user
  const id = yield select(selectAuthUser);
  const patientUser = yield call(fetchUser, { id });
  let rootUser = {};
  // fetch current master
  const currentToken = yield select(selectCurrentToken);
  if (currentToken && !includes(currentToken.roles, 'widget')) {
    const masterId = yield select(selectAuthMaster);
    rootUser = yield call(fetchMaster, { id: masterId });
  }
  window.localStorage.setItem(
    LOGGER_DATA_LOCAL_STORAGE_KEY,
    JSON.stringify({
      patientId: get(patientUser, 'data._id', ''),
      rootId: get(rootUser, 'data._id', ''),
    }),
  );
}
